import React, { useEffect, useContext, useState } from 'react';
import useStateWithCallback from './useStateWithCallback'; // Import the custom hook

import './BattleScreen.css'; // Import CSS for styling
import '../src/styles/font.css';
import { ScreenContext } from './App';

import playerProfile from './Assets/Images/GameBoard/GamePlayIcons/LocalPlayerBar/playerProfile.png';
import playerProfileLevel from './Assets/Images/GameBoard/GamePlayIcons/LocalPlayerBar/LocalPlayerCountBG.png';
import playerProfile2 from './Assets/Images/GameBoard/GamePlayIcons/PlayerTurnList/Player2Icons/Player2Profile.png';

import winnerPlayerHighlighter from './Assets/Images/GameBoard/BattleScreen/battleWinnerHighlightNew.png'

import DiceRollBG from './Assets/Images/GameBoard/BattleScreen/DiceRollBG.png';
import wrongBtn from './Assets/Images/GameBoard/WrongBtn.png';
import rightBtn from './Assets/Images/GameBoard/RightBtn.png';
import bgimg from "./Assets/Images/GameBoard/BattleScreen/Play Screen.png";
import redrightimg from "./Assets/Images/GameBoard/BattleScreen/red-right-removebg-preview.png";
import blueleftimg from "./Assets/Images/GameBoard/BattleScreen/blue-left-removebg-preview.png";

import moveIcon from './Assets/Images/GameBoard/BattleScreen/MoveIcon.png';
import moveIconRight from './Assets/Images/GameBoard/BattleScreen/MoveIconRight.png';
import redDice from './Assets/Images/GameBoard/BattleScreen/RedDice.png';
import redAnimationSprite from './Assets/Images/GameBoard/BattleScreen/diceAnimationSprite.png';



// Dice Imports
import * as CANNON from 'https://cdn.skypack.dev/cannon-es';
import * as THREE from 'three';
import { mergeVertices, mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
//import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils.js'; // Adjust the path accordingly
import './Threejs-rolling-dice-tutorial-master/css/base.css'; // Import the base.css file

import { PlayersDataExport, currentTurnPlayerExport, updateTerritoryDataExport, territoryBoardDataExport } from './GameBoard';

// Dice Imports
import Dice1 from './Assets/Images/GameBoard/BattleScreen/DiceAnimation/Dice1.png';
import Dice2 from './Assets/Images/GameBoard/BattleScreen/DiceAnimation/Dice2.png';
import Dice3 from './Assets/Images/GameBoard/BattleScreen/DiceAnimation/Dice3.png';
import Dice4 from './Assets/Images/GameBoard/BattleScreen/DiceAnimation/Dice4.png';
import Dice5 from './Assets/Images/GameBoard/BattleScreen/DiceAnimation/Dice5.png';
import Dice6 from './Assets/Images/GameBoard/BattleScreen/DiceAnimation/Dice6.png';
import Dice7 from './Assets/Images/GameBoard/BattleScreen/DiceAnimation/Dice7.png';
import Dice8 from './Assets/Images/GameBoard/BattleScreen/DiceAnimation/Dice8.png';

import {  attackerDiceNumberExport, defenderDiceNumberExport, SetBattleResultDataExport } from './GameBoard';

let isBattleScreenClosedExport;
let handleZIndexChangeExport;
let initializeBattleScreenDataExport;
let BattleDataExport;

const BattleScreen = ({ isVisible, onClose }) => {

  //console.log('Battle Screen Loaded');

  const [zIndex, setZIndex] = useState(-99); // Initial z-index value
  const [imageIndex, setImageIndex] = useState(0);
  const [isRollEnabled, setIsRollEnabled] = useState(true);
  const [animationClass, setAnimationClass] = useState('');

  const handleScreenChange = useContext(ScreenContext);

  const [throwDiceValues, setThrowDiceValues] = useStateWithCallback({ attacker: 1, defender: 1, isThrowDice: false }, (newState) => {
    console.log('throwDiceValues updated:', newState);
    
    
    //const diceRollCount = newState.attacker > 3 ? 3 : newState.attacker - 1; //territoryAttacker.troopsCount > 3 ? 3 : (territoryAttacker.troopsCount - 1);
    const diceRollCount = Math.max(newState.attacker > 3 ? 3 : newState.attacker - 1, 0);
    console.log(` Updated Dice Image Index ====> ${diceRollCount} `);
    setCurrentThrowDiceImage(throwDiceImage[diceRollCount]);

    if (defendingTerritory != null && defendingTerritory != undefined && newState.isThrowDice === true) {
      if (defendingTerritory.territoryRuler === 'Player1') {
        if (!isAIFirstTimeDiceRolled) {
          console.log(" AI has not rolled first time dice, rolling first time dice by AI ");
  
          setTimeout(async () => { // Mark the setTimeout callback as async
            setIsDiceRolled(true);
            setIsRollEnabled(false);
            setIsAIFirstTimeDiceRolled(true);
  
            console.log(` Defending Territory ====> ${JSON.stringify(defendingTerritory)} || Attacking Territory ====> ${JSON.stringify(attackingTerritory)}`);
  
            const isAItoLocalAttack = defendingTerritory.territoryRuler === 'Player1';
            const isAItoAIAttack = defendingTerritory.territoryRuler !== 'Player1';
            console.log(`Throw Dice has been called inside Throw Dice Value Update`);
            await throwDice(isAItoLocalAttack, isAItoAIAttack, newState.attacker, newState.defender);
  
          }, 2000);
        }
      }
    }

  //  throwDice(newState.attacker, newState.defender); // Call throwDice with updated values
  });

  // To update both attacker and defender values together
  const updateThrowDiceValues = (attackerValue, defenderValue, throwDiceBol) => {
    setThrowDiceValues({ attacker: attackerValue, defender: defenderValue, isThrowDice: throwDiceBol });
  };


  const [maxDiceRollCount, setMaxDiceRollCount] = useState(0);

  const [isResultCalculated, setIsResultCalcualted] = useState(false);

  // Function to update value1
  const updateAttackerDiceValue = (newValue) => {
    //console.log(`Updated Attacked Dice Value ====> ${newValue}`);
    //setattackerDiceValue(newValue);
  };

  // Function to update value2
  const updatedefenderDiceValue = (newValue) => {
    console.log(`Updated Defender Dice Value ====> ${newValue}`);
   // setdefenderDiceValue(newValue);
  };

 // console.log(`Throw Dice Number ====> ${throwDiceNumber}`);

  const imagePaths = [
    Dice1,
    Dice2,
    Dice3,
    Dice4,
    Dice5,
    Dice6,
    Dice7,
    Dice8,
  ];

  const diceImage = [
    require('./Assets/Images/GameBoard/BattleScreen/Dice/Dice0.png'),
    require('./Assets/Images/GameBoard/BattleScreen/Dice/Dice1.png'),
    require('./Assets/Images/GameBoard/BattleScreen/Dice/Dice2.png'),
    require('./Assets/Images/GameBoard/BattleScreen/Dice/Dice3.png'),
    require('./Assets/Images/GameBoard/BattleScreen/Dice/Dice4.png'),
    require('./Assets/Images/GameBoard/BattleScreen/Dice/Dice5.png'),
    require('./Assets/Images/GameBoard/BattleScreen/Dice/Dice6.png'),
  ];

  const throwDiceImage = [
    require('./Assets/Images/GameBoard/BattleScreen/ThrowableDice/Dice1.png'),
    require('./Assets/Images/GameBoard/BattleScreen/ThrowableDice/Dice2.png'),
    require('./Assets/Images/GameBoard/BattleScreen/ThrowableDice/Dice3.png'),
  ];

  const [BattleData, setBattleData]  = useState ({

    Attacker: {
      diceValues: [0,0,0],
      troopsCount: 0,
    },

    Defender: {
      diceValues: [0,0,0],
      troopsCount: 0,
    },

    BattleStatus:{
      winnerPlayer: '',
      looserPlayer: '',
    }

  });

  //#region Async Update

  const [updateCount, setUpdateCount] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      // Update state to trigger re-render
     // console.log(`Battle Screen Re rendered`);
      setUpdateCount(prevCount => prevCount + 1);
    }, 1000); // Update every 5 seconds (adjust interval as needed)

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);


  //#endregion

  // Use useEffect to log BattleData after it has been updated
  useEffect(() => {

    const isNonZeroValue = BattleData.Attacker.diceValues.some(value => value !== 0) || BattleData.Defender.diceValues.some(value => value !== 0);
    const isBattleFinished = BattleData.BattleStatus.winnerPlayer !== '' && BattleData.BattleStatus.looserPlayer !== '';
   
    
    if (isNonZeroValue && !isResultCalculated) {
     // performBattleResult();
    }

    if (isBattleFinished) {
      performResultAction();
    }
 
  }, [BattleData]);


  const [CurrentThrowDiceImage, setCurrentThrowDiceImage] = useState(throwDiceImage[0]);

  const [isBattleScreenClosed, setisBattleScreenClosed] = useState(false);
  
  // Dice Image
  const [defenderDiceCurrentImage1, setDefenderDiceCurrentImage1] = useState(diceImage[0]);
  const [defenderDiceCurrentImage2, setDefenderDiceCurrentImage2] = useState(diceImage[0]);
  const [defenderDiceCurrentImage3, setDefenderDiceCurrentImage3] = useState(diceImage[0]);

  const [attackerDiceCurrentImage1, setAttackerDiceCurrentImage1] = useState(diceImage[0]);
  const [attackerDiceCurrentImage2, setAttackerDiceCurrentImage2] = useState(diceImage[0]);
  const [attackerDiceCurrentImage3, setAttackerDiceCurrentImage3] = useState(diceImage[0]);


  // Profile Image
  //const [defenderCurrentImage, setDefenderCurrentImage] = useState(diceImage[0]);
  //const [defenderCurrentImage, setDefenderCurrentImage] = useState(diceImage[0]);



  const [defendingTerritory, setDefendingTerritory] = useState(null);
  const [attackingTerritory, setAttackingTerritory] = useState(null);

  const [defendingPlayerProfileImage, setDefendingPlayerProfileImage] = useState(playerProfile);
  const [attackingPlayerProfileImage, setAttackingPlayerProfileImage] = useState(playerProfile2);

  const [defendingPlayerWinner, setDefendingPlayerWinner] = useState(false);
  const [attackingPlayerWinner, setAttackingPlayerWinner] = useState(false);

  const [isAIFirstTimeDiceRolled, setIsAIFirstTimeDiceRolled] = useState(false);

  const [isDiceRolled, setIsDiceRolled] = useState(false);
  const [hasPerfromedAction, setHasPerformedAction] = useState(false);

  const [isLocalPlayerAttacking, setIsLocalPlayerAttacking] = useState(false);


  useEffect(() => {
    if (isVisible) {

      setDefenderDiceCurrentImage1(diceImage[imageIndex]);
      setDefenderDiceCurrentImage2(diceImage[imageIndex]);
      setDefenderDiceCurrentImage3(diceImage[imageIndex]);

      setAttackerDiceCurrentImage1(diceImage[imageIndex]);
      setAttackerDiceCurrentImage2(diceImage[imageIndex]);
      setAttackerDiceCurrentImage3(diceImage[imageIndex]);
      
    }
  }, [isVisible]); // Run this effect when isVisible changes


  useEffect(() =>
  {
    if(isBattleScreenClosed){
      setTimeout(() => {

        setisBattleScreenClosed(false);
        console.log(`Battle Screen Is Closed set Back to False`);

      }, 2000);
    }

  },[isBattleScreenClosed] );

  useEffect(() =>{
    console.log(`Actionable Territories Data Updated`);

  //  console.log(` [${new Date().toLocaleString()}] || Defending Territory Updated || DATA ====>  ${JSON.stringify(defendingTerritory)}`);

    if(PlayersDataExport === null || PlayersDataExport === undefined){
      return;
    }
    const playerList = [...PlayersDataExport];

      // Set Defending Player Dice Roll Count


    if(playerList[currentTurnPlayerExport - 1].playerName !== 'Player1'){

      console.log(`Player ====> ${playerList[currentTurnPlayerExport-1].playerName} || isAI ====>  ${playerList[currentTurnPlayerExport - 1].isBotAI}`);


      if (!isAIFirstTimeDiceRolled) {
      //  if(defendingTerritory != null && defendingTerritory != undefined){

         
       // }

        if(attackingTerritory != null && attackingTerritory != undefined){

          // Defender Dice Count
          const DefenderThrowDiceCount = defendingTerritory.troopsCount >= 2 ? 2 : 1;
          console.log(` Set Defender Dice Throw Count ====>  ${DefenderThrowDiceCount}`);
         // setThrowDiceNumberDefender(DefenderThrowDiceCount);


          // Attacker Dice Count
          const AiThrowDiceCount = attackingTerritory.troopsCount > 3 ? 3 : (attackingTerritory.troopsCount - 1);
          console.log(` Set AI Dice Throw Count ====>  ${AiThrowDiceCount}`);
         // setThrowDiceNumberAttacker(AiThrowDiceCount);

         updateThrowDiceValues(AiThrowDiceCount, DefenderThrowDiceCount, true);

        }
      }
     
    }else{

       //  if(defendingTerritory.territoryRuler === 'Player1'){

       if(defendingTerritory != null &&  defendingTerritory != undefined){

        // Set Local Player Max Dice Roll Bound
        if(attackingTerritory.territoryRuler === 'Player1'){

          setIsLocalPlayerAttacking(true);
          const maxDiceRoll = attackingTerritory.troopsCount <= 3 ? attackingTerritory.troopsCount - 1 : 3;
          setMaxDiceRollCount(maxDiceRoll);
    
        }

      }

     // }
     
      setIsRollEnabled(true);
    }

  }, [defendingTerritory, attackingTerritory])


  //====================================>
  //Function to Update battle Data
  //====================================>
  const updateBattleData = (player, property, index, value) => {
    console.log('Update Battle Data Called with:', player, property, index, value);

    setBattleData(prevBattleData => {
        console.log('Previous Battle Data:', prevBattleData);

        const updatedData = {
            ...prevBattleData,
            [player]: {
                ...prevBattleData[player],
                [property]: prevBattleData[player][property].map((item, i) => i === index ? value : item)
            }
        };

        console.log('Updated Battle Data:', updatedData);
        return updatedData;
    });
  };

  //====================================>
  // Function to Reset Battle Round Data
  //====================================>
  const resetBattleRound = async (isAItoLocalAttack) => {
    console.log('Battle Round Reset');
    setIsDiceRolled(false);


    if (isAItoLocalAttack) { // Old Conditions

   //if(attackingTerritory !== null && attackingTerritory !== undefined){


   
        console.log(`Reset Battle Round is AI to Local attack || Calling Dice Roll`);

       // console.log(`throw Dice Number Attacker ====> ${throwDiceNumberAttacker} || throw Dice Number Defender ====> ${throwDiceNumberDefender}`);
        
        const territoryAttacker = territoryBoardDataExport.find(territory => territory.id === attackingTerritory.id);
        const territoryDefender = territoryBoardDataExport.find(territory => territory.id === defendingTerritory.id);

        console.log(`Attacker Territory Data ====> ${JSON.stringify(territoryAttacker)}`);
        console.log(`Defender Territory Data ====> ${JSON.stringify(territoryDefender)}`);


        const DefenderThrowDiceCount = territoryDefender.troopsCount >= 2 ? 2 : 1;
        console.log(`Set Defender Dice Throw Count ====> ${DefenderThrowDiceCount}`);

        const AiThrowDiceCount = territoryAttacker.troopsCount > 3 ? 3 : (territoryAttacker.troopsCount - 1);
        console.log(`Set AI Dice Throw Count ====> ${AiThrowDiceCount}`);

        updateThrowDiceValues(AiThrowDiceCount, DefenderThrowDiceCount, true);


        const maxDiceRoll = territoryAttacker.troopsCount > 3 ? 3 : (territoryAttacker.troopsCount - 1);
        console.log(`Max Dice Roll Count: ${maxDiceRoll}`);
        setMaxDiceRollCount(maxDiceRoll);
    
  //  }
    }
}


  const resetDiceValues = () => {
    setBattleData(prevBattleData => {
        const updatedData = {
            ...prevBattleData,
            Attacker: {
                ...prevBattleData.Attacker,
                diceValues: [0, 0, 0] // Set Attacker's dice values to zeros
            },
            Defender: {
                ...prevBattleData.Defender,
                diceValues: [0, 0, 0] // Set Defender's dice values to zeros
            }
        };
        return updatedData;
    });
  };

  //==================================================>
  // Function to update the troop count of territory
  //==================================================>
  const updateTroopCount = (newTroopCount, targetTerritory) => {

    //console.log(`Is Attacking Territory Troops Update ====> ${targetTerritory.id === attackingTerritory.id} || updated Troops Count =====< ${newTroopCount}`);
    if(targetTerritory.id === attackingTerritory.id){

    // console.log('Attacking Territory Troops Data updated');

      setAttackingTerritory((prevState) => ({
        ...prevState,
        troopsCount: newTroopCount,
      }));

    }else{

     // console.log('Attacking Territory Troops Data updated');

      setDefendingTerritory((prevState) => ({
        ...prevState,
        troopsCount: newTroopCount,
      }));

    }
    
  };


  const updateBattleStatus = (newStatus) => {
    console.log('Update Battle Status Data Called');
    setBattleData(prevBattleData => {
      return {
        ...prevBattleData,
        BattleStatus: {
          ...prevBattleData.BattleStatus,
          ...newStatus
        }
      };
    });
  };


  //====================================>
  //Function to Render BattleScreen
  //====================================>
  const handleZIndexChange = (isAutoPlayDice) => {
    
    console.log(`Is Auto Play Dice ====> ${isAutoPlayDice}`);
    // Change the z-index value
    setZIndex(prevZIndex => prevZIndex === 99 ? -99 : 99);
    
  };

  //===========================================>
  //Function to Initialize Battle Screen Data
  //===========================================>
  const initializeBattleScreenData = async (attackingTerritoryData, defendingTerritoryData, attackingPlayerProfile, defendingPlayerProfile) => {
    console.log(`${new Date().toLocaleTimeString()}: Initialize Battle Screen Data`);

    console.log(`${new Date().toLocaleTimeString()}: Attacking Territory Data ====> ${JSON.stringify(attackingTerritoryData)}`);
    console.log(`${new Date().toLocaleTimeString()}: Defending Territory Data ====> ${JSON.stringify(defendingTerritoryData)}`);

    await resetBattleRound(false);

    console.log(`${new Date().toLocaleTimeString()}: Territories data has been updated`);

    setIsAIFirstTimeDiceRolled(false);

    setAttackingTerritory(attackingTerritoryData);
    setDefendingTerritory(defendingTerritoryData);

    setAttackingPlayerProfileImage(attackingPlayerProfile);
    setDefendingPlayerProfileImage(defendingPlayerProfile);
    
    //Reset Dice
    setDefenderDiceCurrentImage1(diceImage[imageIndex]);
    setDefenderDiceCurrentImage2(diceImage[imageIndex]);
    setDefenderDiceCurrentImage3(diceImage[imageIndex]);

    setAttackerDiceCurrentImage1(diceImage[imageIndex]);
    setAttackerDiceCurrentImage2(diceImage[imageIndex]);
    setAttackerDiceCurrentImage3(diceImage[imageIndex]);


    // Reset Winner Status
    setAttackingPlayerWinner(false);
    setDefendingPlayerWinner(false);

    setisBattleScreenClosed(false);

    setHasPerformedAction(false);

    if(attackingTerritoryData.territoryRuler === 'Player1'){

      setIsLocalPlayerAttacking(true);

    }else{

      setIsLocalPlayerAttacking(false);

    }

  //  InitializeBattleData();

  }
  
  const callThrowDice = async () => {

    if(!isRollEnabled){
      console.log(` Roll Dice not enabled returning back ====> ${isRollEnabled}`);
      return;
    }

    setIsDiceRolled(true);
  

   // setTimeout(() => {
      await throwDice(false, false, throwDiceValues.attacker, throwDiceValues.defender);  
   // }, 1500);
    

  }

  //================================>
  // Fucntion to roll Dice
  //================================>
  const throwDice = async (isAItoLocalAttack, isAItoAIAttack, throwDiceNumberAttackerData, throwDiceNumberDefenderData ) => {


    setIsRollEnabled(false);
    console.log('Throw Dice Called');

    console.log(`Is AI to Local Attack ====> ${isAItoLocalAttack} || is AI to AI Attack ====> ${isAItoAIAttack}`);

    const attackerDiceValues = [];
    const defenderDiceValues = [];

    console.log(`throw Dice Number Attacker ====> ${throwDiceNumberAttackerData} || throw Dice Number Defender ====> ${throwDiceNumberDefenderData}`);

    for (let i = 0; i < throwDiceNumberAttackerData; i++) {
      const diceVal = rollDice();
      attackerDiceValues.push(diceVal);
    }

    for (let i = 0; i < throwDiceNumberDefenderData; i++) {
      const diceVal = rollDice();
      defenderDiceValues.push(diceVal);
    }

    const sortedDefenderDiceVal = defenderDiceValues.sort((a, b) => b - a);
    const sortedAttackerDiceVal = attackerDiceValues.sort((a, b) => b - a);

    console.log(`Attacker Dice Value =====> ${sortedAttackerDiceVal} || Defender Dice Value =====> ${sortedDefenderDiceVal}`);
    let spriteIndex = 0;

    // Function to switch to the next sprite
    function nextSprite() {
        if (spriteIndex < imagePaths.length) {
            const attackerimage = imagePaths[spriteIndex];
            setAttackerDiceCurrentImage1(attackerimage);
            setAttackerDiceCurrentImage2(attackerimage);
            setAttackerDiceCurrentImage3(attackerimage);
            const defenderimage = imagePaths[spriteIndex]
            setDefenderDiceCurrentImage1(defenderimage);
            setDefenderDiceCurrentImage2(defenderimage);
            setDefenderDiceCurrentImage3(defenderimage);
            spriteIndex++;
        } else {
          console.log('Dice Image Set As per outcome');
          for(let i=0; i<throwDiceNumberAttackerData; i++){
            if(i == 0){
              setAttackerDiceCurrentImage1(diceImage[sortedAttackerDiceVal[i]]);
            }

            if(i==1){
              setAttackerDiceCurrentImage2(diceImage[sortedAttackerDiceVal[i]]);

            }

            if(i==2){
              setAttackerDiceCurrentImage3(diceImage[sortedAttackerDiceVal[i]]);

            }
          }

          for(let i=0; i<throwDiceNumberDefenderData; i++){
            if(i == 0){
              setDefenderDiceCurrentImage1(diceImage[sortedDefenderDiceVal[i]]);
            }

            if(i==1){
              setDefenderDiceCurrentImage2(diceImage[sortedDefenderDiceVal[i]]);

            }

            if(i==2){
              setDefenderDiceCurrentImage3(diceImage[sortedDefenderDiceVal[i]]);

            }

           // setDefenderDiceCurrentImage1(diceImage[defenderDiceValues[i]]);
          }
          
        }
    }

    // Start the animation loop
    const animationInterval = setInterval(nextSprite, 100); // Adjust the interval for smoother or faster animation

    // Optionally, stop the animation after a certain duration
   // setTimeout(() => {

    await new Promise(resolve => setTimeout(resolve, 1500));
    
        clearInterval(animationInterval);
        
       // setTimeout(() => {

          console.log('Performed Battle Result Called');
          await performBattleResult(defenderDiceValues, attackerDiceValues, isAItoLocalAttack, isAItoAIAttack)
          
      //  }, 2000);

   // }, 1500); 

  }

  function rollDice() {
    // Generate a random number between 1 and 6
    return Math.floor(Math.random() * 6) + 1;
  }

  //=========================================================>
  //Function to perform Battle result based on dice results
  //=========================================================>
  const performBattleResult = async (defenderDiceVal, attackerDiceVal, isAItoLocalAttack, isAItoAIAttack) => {

    console.log(`defender Dice Count =====> ${defenderDiceVal} || attacker Dice Count =====> ${attackerDiceVal}`);
    console.log(` IS AI to local player attack ====> ${isAItoLocalAttack}`);

    let defenderWinStreak = 0; //  defenderDiceVal;
    let attackerWinStreak = 0; //attackerDiceVal;

    //#region  AI to AI Battle

    if(isAItoAIAttack){

      defenderWinStreak = rollDice();
      attackerWinStreak = rollDice();

      if (attackerWinStreak > defenderWinStreak) {
        setAnimationClass('scale-up-down');
        console.log(`Attacker has won the battle`);
        setAttackingPlayerWinner(true);
        updateBattleStatus({ winnerPlayer: attackingTerritory.territoryRuler, looserPlayer: defendingTerritory.territoryRuler });
        
      } else {
        setAnimationClass('scale-up-down');
        //setAnimationClass('');
        console.log(`Defender has won the battle`);
        setDefendingPlayerWinner(true);
        updateBattleStatus({ winnerPlayer: defendingTerritory.territoryRuler, looserPlayer: attackingTerritory.territoryRuler });  
      }

      return;
      
    }


    //#endregion

    const sortedDefenderDiceVal = defenderDiceVal;//.sort((a, b) => b - a);
    const sortedAttackerDiceVal = attackerDiceVal;//.sort((a, b) => b - a);

   
    //let troopsFightCount = 0;

   // setIsResultCalcualted(true);

   const countCheck = sortedDefenderDiceVal.length > sortedAttackerDiceVal.length ? sortedAttackerDiceVal.length : sortedDefenderDiceVal.length;

   console.log(`Final Troop Battle Count ====> ${countCheck}`);

   for (let i = 0; i < countCheck; i++) {
    // Check if attacker dice value is greater than defender dice value
    if (sortedAttackerDiceVal[i] > sortedDefenderDiceVal[i]) {
      attackerWinStreak++;
    } else {
      defenderWinStreak++;
    }

    // Break the loop if attacker dice value is less than defender dice value
    if (i + 1 >= attackerDiceVal.length) {
      break;
    }
    }

    console.log(`Attacker Win Streak Count ====> ${attackerWinStreak} || Defender Win Streak Count ====> ${defenderWinStreak}`);

    let territoryAttacker = territoryBoardDataExport.find(territory => territory.id === attackingTerritory.id);
    let territoryDefender = territoryBoardDataExport.find(territory => territory.id === defendingTerritory.id);


    console.log(` Attacking Territory Data at Update Troops ====> ${JSON.stringify(territoryAttacker)}`);
    const updatedAttackerTroopsCount = territoryAttacker.troopsCount - defenderWinStreak;
    console.log(` Updated Attacker Troops Count ====> ${updatedAttackerTroopsCount}`);

    console.log(` Defending Territory Data at Update Troops ====> ${JSON.stringify(territoryDefender)}`);
    const updatedDefenderTroopsCount = territoryDefender.troopsCount - attackerWinStreak;
    console.log(` Updated Defender Troops Count ====> ${updatedDefenderTroopsCount}`);

    // Update Attacker Territory Troops Count
    updateTerritoryDataExport(attackingTerritory.id, {
      troopsCount: updatedAttackerTroopsCount,
    });

    updateTroopCount(updatedAttackerTroopsCount, attackingTerritory);

    // Update Defender Territory Troops Count
    updateTerritoryDataExport(defendingTerritory.id, {
      troopsCount: updatedDefenderTroopsCount,
    });

    updateTroopCount(updatedDefenderTroopsCount, defendingTerritory);

    console.log(`Updated Attacker Troops Count ====> ${updatedAttackerTroopsCount} || Updated Defender Troops Count ====> ${updatedDefenderTroopsCount}`);

    if(updatedAttackerTroopsCount <= 1 && updatedDefenderTroopsCount > 0){

      // Defender Won the Battle

      setDefendingPlayerWinner(true);    
     // setIsAIFirstTimeDiceRolled(false); 

      await new Promise(resolve => setTimeout(resolve, 2000));
     
      updateBattleStatus({ winnerPlayer: defendingTerritory.territoryRuler, looserPlayer: attackingTerritory.territoryRuler });
     

      return;

    }else if(updatedDefenderTroopsCount <= 0 && updatedAttackerTroopsCount > 0){

      // Attacker Won the Battle

      setAttackingPlayerWinner(true);
     // setIsAIFirstTimeDiceRolled(false);

     
      await new Promise(resolve => setTimeout(resolve, 2000));
        
      updateBattleStatus({ winnerPlayer: attackingTerritory.territoryRuler, looserPlayer: defendingTerritory.territoryRuler });
     

    
      return;
     // updateBattleStatus({ winnerPlayer: attackingTerritory.territoryRuler, looserPlayer: defendingTerritory.territoryRuler });
      
    }


    await new Promise(resolve => setTimeout(resolve, 2000));

   // setTimeout(() => {

   /* territoryAttacker = territoryBoardDataExport.find(territory => territory.id === attackingTerritory.id);
    territoryDefender = territoryBoardDataExport.find(territory => territory.id === defendingTerritory.id);

    if (territoryDefender != null && territoryDefender != undefined) {
        const DefenderThrowDiceCount = territoryDefender.troopsCount >= 2 ? 2 : 1;
        console.log(`Set Defender Dice Throw Count ====> ${DefenderThrowDiceCount}`);
        setThrowDiceNumberDefender(DefenderThrowDiceCount);
    }

    if (territoryAttacker != null && territoryAttacker != undefined) {
        const AiThrowDiceCount = territoryAttacker.troopsCount > 3 ? 3 : (territoryAttacker.troopsCount - 1);
        console.log(`Set AI Dice Throw Count ====> ${AiThrowDiceCount}`);
        setThrowDiceNumberAttacker(AiThrowDiceCount);
    } */

    await resetBattleRound(true);//isAItoLocalAttack);

   // }, 2000);

    //debugger;
  };

  const performResultAction = () => {


    console.log(`Perform Action ====> ${hasPerfromedAction}`);

    if(hasPerfromedAction){
      return;
    }

    setHasPerformedAction(true);

    console.log(`Is Battle Screen Closed ====> ${isBattleScreenClosed}`);
    if(isBattleScreenClosed){
        return;
    }
      
    setTimeout(() => {
    
      console.log('Battle Result Data has been updated in GameBoard.jsx');

      setTimeout(() => {

          console.log(`Closing Battle Screen`);

          setisBattleScreenClosed(true);
          updateThrowDiceValues(1 ,1, false);
          handleZIndexChange(false);
          
          console.log(`Standard Dice Data ====> ${JSON.stringify(BattleData)}`);
      }, 3000);
    }, 1000);

  }

  //#region  Dice Rolling Functionalities



  //#endregion

  const BattleDataLog = () => {
      console.log(`Battle Data Value Log ====> ${JSON.stringify(BattleData)}`);
  }

  const handleThrowDiceNumberDecrease = () => {
    //return;
    console.log('Decrease');
    updatetThrowDiceNumber(false);
  };
  
  const handleThrowDiceNumberIncrease = () => {
    //return;
    console.log('Increase');
    updatetThrowDiceNumber(true);
  };

  const updatetThrowDiceNumber = (isIncrease) => {

    console.log('Update Dice throe Number Value Increased');

   // console.log(`Throw Dice Number Value Before ====> ${throwDiceNumberAttacker}`);

    const maxDiceRoll = attackingTerritory.troopsCount <= 3 ? attackingTerritory.troopsCount - 1 : 3;
    setMaxDiceRollCount(maxDiceRoll);

    const defenderRollValue = defendingTerritory.troopsCount >= 2 ? 2 : 1;

    if(isIncrease){
    //  console.log(`THrow Dice Number ====> ${throwDiceNumber}`);

      

      if(throwDiceValues.attacker === maxDiceRollCount){
       // setThrowDiceNumberAttacker(1);
        console.log(`Updated Dice Number If ====> ${1}`);
        updateThrowDiceValues(1, defenderRollValue, true);

      }else{
        console.log(`Updated Dice Number Else ====> ${(throwDiceValues.attacker + 1)}`);
       // setThrowDiceNumberAttacker(throwDiceNumberAttacker+1);
        updateThrowDiceValues((throwDiceValues.attacker + 1), defenderRollValue, true);
      }


    }else{

      if(throwDiceValues.attacker === 1){
        //setThrowDiceNumberAttacker (maxDiceRollCount);
        updateThrowDiceValues(maxDiceRollCount, defenderRollValue, true);
      }
      else{
        updateThrowDiceValues((throwDiceValues.attacker - 1), defenderRollValue, true);
        //setThrowDiceNumberAttacker(throwDiceNumberAttacker-1);
      }
    }

  //  console.log(`Throw Dice Number Value After ====> ${throwDiceNumberAttacker}`);

   // setCurrentThrowDiceImage(throwDiceImage[throwDiceNumberAttacker]);
  }

  //#region Dice Rolling

  //#endregion


 
  //#endregion

  isBattleScreenClosedExport = isBattleScreenClosed;
  handleZIndexChangeExport = handleZIndexChange;
  initializeBattleScreenDataExport = initializeBattleScreenData;
  BattleDataExport = BattleData;

  return (
    
     //<div className={`battle-screen`} style={{ zIndex, visibility: zIndex === -99  ? 'hidden' : 'visible'}}>

     
    <div
    className={`battle-screen`}
    style={{ zIndex, visibility: zIndex === -99 ? "visible" : "visible" }}
    >

        {/* Territory Image}

       {/* style={{ zIndex }} */}
        <img src={bgimg} style={{ height: "100vh", width: "100%" , zIndex:"-2" }} />
        <div style={{position:'absolute' , width:"34%" , left:"55%" , top:"17%"  , height:"55%"}}>
          <img
            src={redrightimg}
            style={{ width: "100%" , height:"100%" }}
          />
        </div>
        <div style={{position:'absolute' , width:"34%" , left:"12%" , top:"23%" , height:"47%"}}>
          <img
            src={blueleftimg}
            style={{ width: "100%" ,  height:"100%" }}
          />
        </div>

  
      {/* Player Profile*/}

        <div>
          <div
            style={{
              position: "absolute",
              width: "48%",
              top: "76%",
              left: "12%",
            }}
          >
            <img
              src={attackingPlayerProfileImage}
              alt="Left Image"
              className="profile-image"
            />
            <img
              src={playerProfileLevel}
              alt="Left Image"
              className="level-bg"
              style={{ bottom: "70%", width: "9%" }}
            />
            {attackingTerritory && ( 
            <div
              style={{
                position: "absolute",
                bottom: "79%",
                left: "15%",
                transform: "translateX(-50%)",
                zIndex: 4,
                fontWeight: "bold",
                color: "white",
                fontSize: "2.2vw",
                fontFamily: "Gomarice",
              }}
            >
              
              {(attackingTerritory.troopsCount)} {/*attackingTerritory.troopsCount > 0 ? attackingTerritory.troopsCount : 0 */}
            </div>
            )}
            {attackingPlayerWinner && (
            <img
              src={winnerPlayerHighlighter}
              alt="Highlight Image"
              className="highlight-image-left"
              style={{ width: "64%", top: "-110%", left: "-22%" }}
            />
            )}
          </div>
          <div
            style={{
              position: "absolute",
              width: "48%",
              top: "76%",
              left: "77%",
            }}
          >
            <img
              src={defendingPlayerProfileImage}
              alt="Left Image"
              className="profile-image"
            />
            <img
              src={playerProfileLevel}
              alt="Left Image"
              className="level-bg"
              style={{ bottom: "70%", width: "9%" }}
            />
            {defendingTerritory && (
            <div
              style={{
                position: "absolute",
                bottom: "79%",
                left: "15%",
                transform: "translateX(-50%)",
                zIndex: 4,
                fontWeight: "bold",
                color: "white",
                fontSize: "2.2vw",
                fontFamily: "Gomarice",
              }}
            >
              {( defendingTerritory.troopsCount )} {/*  defendingTerritory.troopsCount > 0 ? defendingTerritory.troopsCount : 0  */}
            </div>
            )}
            {defendingPlayerWinner && (
            <img
              src={winnerPlayerHighlighter}
              alt="Highlight Image"
              className="highlight-image-left"
              style={{ width: "64%", top: "-110%", left: "-22%" }}
            />
            )}
          </div>
        </div>

        <div className="image-container"> 



        {/* Dice Selection Move Bar */}
        {/* Temprory Dice Section */}

        {( isLocalPlayerAttacking && !isDiceRolled  &&
          <div className="dice-selection-bar">
            { maxDiceRollCount > 1 && (
              <img src={moveIcon} alt="Left Image" className="move-icon left" onClick={handleThrowDiceNumberDecrease} />
            )}
            {/*} {( throwDiceNumber === 0 && */}
            <img src={CurrentThrowDiceImage} alt="Attacker Dice" className="dice-roller-count" style={{ position: 'absolute', top: '-25%', left: '45%', width:'10%', height:'auto'}} />
            {/*})} */}
          
            { maxDiceRollCount > 1  && (
            <img src={moveIconRight} alt="Right Image" className="move-icon right" onClick={handleThrowDiceNumberIncrease} />
            )}
            {/* <div className="roll-count">0</div> */}
          </div>
        )} 
        {/* */}

          {/* Defender Dice Dummy Aniamtion */}
          {(isDiceRolled && throwDiceValues.attacker >= 1 &&
            <img src={attackerDiceCurrentImage1} alt="defender Dice" className="defender-dice" />
          )}
           {( isDiceRolled && throwDiceValues.attacker >= 2 &&
            <img src={attackerDiceCurrentImage2} alt="defender Dice" className="defender-dice2" />
           )}
           {( isDiceRolled && throwDiceValues.attacker >= 3 &&
            <img src={attackerDiceCurrentImage3} alt="defender Dice" className="defender-dice3" />
           )}
          

          {/* Attacker Dice Dummy Aniamtion */}
          {(isDiceRolled && throwDiceValues.defender >= 1 &&
            <img src={defenderDiceCurrentImage1} alt="attacker Dice" className="attacker-dice" />
          )}
          {(isDiceRolled && throwDiceValues.defender >= 2  &&
            <img src={defenderDiceCurrentImage2} alt="attacker Dice" className="attacker-dice2" />
          )}
          {(isDiceRolled && throwDiceValues.defender >= 3 &&
            <img src={defenderDiceCurrentImage3} alt="attacker Dice" className="attacker-dice3" />
          )}


        {/* Temprory Dice Section*/}

        {/* Dice Selection Bar */}
        {( isLocalPlayerAttacking && !isDiceRolled &&
        <div className="dice-roll-bar" style={{ zIndex: 10 }}>
          <div className="roll-bg">
            <img src={DiceRollBG} alt="Centered Image" />
            <img src={wrongBtn} alt="Left Image" className="roll-btn left" />
            <img src={rightBtn} alt="Right Image" className="roll-btn right" onClick={callThrowDice} />
            <div style={{ fontFamily: 'Gomarice' }} className="roll-text">Roll the Dice</div> 
          </div>
        </div>
        )}


        {/* Dice Rolling */}

        <main>
        <div className="frame">
       
        </div>
        <div className="content">
          <canvas id="canvas"></canvas>
          <div className="ui-controls">
            <div className="score">
              {/*Score: <span id="score-result"></span> */}
            </div>
         
          </div>
        </div>
        </main>
        </div>

        
    

       {/* Text element 1 */}
        {attackingTerritory && attackingTerritory.territoryName && (
        <div
          style={{
            position: "absolute",
            top: "5%",
            width: "100%",
            textAlign: "center",
            color: "black",
            fontSize: "3vw",
            fontFamily: "Gomarice",
          }}
        >
          {defendingTerritory.territoryName}
        </div>
        )}

        {/* Text element 2 */}
        {attackingTerritory && attackingTerritory.territoryName && (
        <div
          style={{
            position: "absolute",
            top: "15%",
            width: "100%",
            textAlign: "center",
            color: "black",
            fontSize: "3vw",
            fontFamily: "Gomarice",
          }}
        >
          {" "}
          {attackingTerritory.territoryName}
        </div>
        )}


     
    </div>
  );
};

export { isBattleScreenClosedExport, handleZIndexChangeExport, initializeBattleScreenDataExport, BattleDataExport};

export default BattleScreen;